import React, { useContext, useEffect, useState } from "react";
import _ from "lodash";

function EmptySidebar(props) {
    const sidebarImage = "default-sidebar.jpg";
    const sidebarColor = "black";
    return (
        <div className="sidebar" data-image={sidebarImage} data-color={sidebarColor}>
            <div
                className="sidebar-background"
                style={{
                    backgroundImage: "url(" + sidebarImage + ")",
                }}
            />
            <div className="sidebar-wrapper">
                <div className="logo d-flex align-items-center justify-content-start">
                    &nbsp;
                </div>

            </div>
        </div>
    );
}

export default EmptySidebar